<script setup lang="ts">
import {computed, ref, watch} from 'vue';
import StfSheet from '@/ui/sheet/StfSheet.vue';
import {useTrademarkStore} from '@/store/mark';
import {storeToRefs} from 'pinia';
import useMobile from '@/composables/useMobileDependable';

const {isMobile} = useMobile();
const trademarkStore = useTrademarkStore();
const {trademarkWord} = storeToRefs(trademarkStore);
const input = ref(trademarkStore.trademarkWord ? trademarkStore.trademarkWord : '');
const capitalized = ref(true);

const updateTrademarkWord = () => {
    let word = input.value.trim();

    if (word.length === 0) {
        trademarkStore.addTrademarkWord(null);
        return;
    }

    if (capitalized.value) {
        word = word.toUpperCase();
    }

    trademarkStore.addTrademarkWord(word);
}

const wordMaxSize = computed(() => {
    if (!trademarkStore.trademarkWord) {
        return 0;
    }

    //get lenght of the longest word in the string
    return trademarkStore.trademarkWord.split(' ').reduce((a, b) => a.length > b.length ? a : b).length;
});

const cssClass = computed(() => {
    if (wordMaxSize.value > 12 && isMobile.value) {
        return 'stf-text-24';
    }

    return 'stf-text-40';
});

watch(capitalized, () => {
    updateTrademarkWord();
});

watch(input, () => {
    updateTrademarkWord();
});
</script>

<template>
    <StfSubHeading>Add your brand name</StfSubHeading>
    <StfInput v-model="input" placeholder="Type your brand name" class="my-2"/>
    <StfCheckbox v-model="capitalized" label="Words are automatically capitalised for maximum protection" size="small"/>
    <StfSheet v-if="trademarkWord" class="mt-3 stf-word-wrap" :class="cssClass">{{trademarkWord}}</StfSheet>
</template>
